import { createClient } from '@supabase/supabase-js';
import { env } from '@/lib/env';
import { authStorage } from '@/lib/platform/storage';

export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: authStorage,
  },
});
